import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getByCompany() {
        try
        {            
            const response = await axios.get(`FiscalPeriods`,
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api getByCompany error')
            throw error
        }
    },
    async getCurrent() {
        try
        {            
            const response = await axios.get(`FiscalPeriods/current`,
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api getCurrent error')
            throw error
        }
    },
    async getFiscalPeriod(fiscalPeriodId) {
        try
        {            
            const response = await axios.get(`FiscalPeriods/${fiscalPeriodId}`,
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api getFiscalPeriod error')
            throw error
        }
    },
    //not used
    async delete(fiscalPeriodId) {
        try
        {            
            const response = await axios.post(`FiscalPeriods/delete/${fiscalPeriodId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api delete error')
            throw error
        }
    },
    async getUpcoming() {
        try
        {            
            const response = await axios.get(`FiscalPeriods/next`,
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api getUpcoming error')
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`FiscalPeriods`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api add error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.patch(`FiscalPeriods`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api update error')
            throw error
        }
    },
    async approve(data) {
        try
        {            
            const response = await axios.post(`FiscalPeriods/approve`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api approve error')
            throw error
        }
    },
    async reject(data) {
        try
        {            
            const response = await axios.post(`FiscalPeriods/reject`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api reject error')
            throw error
        }
    },
    async close(data) {
        try
        {            
            const response = await axios.post(`FiscalPeriods/close`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.fiscal_periods
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('FiscalPeriods api close error')
            throw error
        }
    }
}